import { CommonOptions, CommonUtils, types } from "@/BaseComponent";

export const forms = {
    clientForm: {
        idx: 0 as number,
        date: 0 as number,
        strDate: "" as string,
        isRealMember: 1 as number,
        year: "" as string,
        month: "" as string,
        days: "" as string,
        number: "" as string,
        dept: 0 as number,
        consultDepartment: "" as string,
        writer: "" as string,
        state: 0 as number,
        counselType: 0 as number,
        counselComment: "" as string,
        location: "" as string,
        locationComment: "" as string,
        counselor: "" as string,
        introducer: "" as string,
        introducerComment: "" as string,
        name: "" as string,
        sex: "" as string,
        jumin1: "" as string,
        jumin2: "" as string,
        jumin: "" as string,
        address: "" as string,
        juminAddress: "" as string,
        addressCurrent: "" as string,
        roommate: "" as string,
        phone: "" as string,
        phone1: "" as string,
        phone2: "" as string,
        phone3: "" as string,
        phoneName: "" as string,
        phoneNameRel: "" as string,
        tel: "" as string,
        tel1: "" as string,
        tel2: "" as string,
        tel3: "" as string,
        telName: "" as string,
        telNameRel: "" as string,
        telEmergency: "" as string,
        telEmergency1: "" as string,
        telEmergency2: "" as string,
        telEmergency3: "" as string,
        telEmergencyName: "" as string,
        telEmergencyNameRel: "" as string,
        email: "" as string,
        age: "" as string,
        ageKor: "" as string,
        foreigner: "" as string,
        foreignerDesc: "" as string,
        guardian: "" as string,
        isHurdles: 0 as number,
        isHurdlesComment: "" as string,
        hurdlesType: "" as string,
        hurdlesReceive: "" as string,
        hurdlesCoverage: "" as string,
        historyDate: "" as string,
        historyAge: "" as string,
        historyYear: "" as string,
        family: "" as string,
        familyEtc: "" as string,
        hasChildEtc: "" as string,
        area: "" as string,
        area1: "" as string,
        area2: "" as string,
        area3: "" as string,
        area4: "" as string,
        areaComment: "" as string,
        type: "" as string,
        typeComment: "" as string,
        price: "" as string,
        priceComment: "" as string,
        broker: "" as string,
        brokerComment: "" as string,
        marriageType: null as number | null,
        isViolence: "" as string,
        isViolenceComment: "" as string,
        isRunaway: "" as string,
        isRunawayComment: "" as string,
        firstRunawayDate: "" as string,
        runawayAge: "" as string,
        runawayYear: "" as string,
        runawayReason: "" as string,
        isSexualViolence: "" as string,
        cntSexualViolence: "" as string,
        sexualViolenceLocation: "" as string,
        sexualViolenceVictims: "" as string,
        sexualViolenceCase: "" as string,
        safetyStatus: "" as string,
        supportLegal: "" as string,
        supportMedical: "" as string,
        supportSelfReliance: "" as string,
        comment: "" as string,
    },

    convertClientDataFromApi: (data: types.client.ClientVOForApi) => {
        forms.clientForm.idx = data.idx;
        forms.clientForm.strDate = CommonUtils.dateFormatYYYYMMDD(data.date, "-");
        forms.clientForm.isRealMember = data.isRealMember;
        forms.clientForm.year = data.year;
        forms.clientForm.month = data.month;
        forms.clientForm.days = data.days;
        forms.clientForm.number = data.number;
        forms.clientForm.dept = data.dept;
        forms.clientForm.consultDepartment = data.consultDepartment;
        forms.clientForm.writer = data.writer;
        forms.clientForm.state = data.state;
        forms.clientForm.counselType = data.counselType;
        forms.clientForm.counselComment = data.counselComment;
        forms.clientForm.location = data.location;
        forms.clientForm.locationComment = data.locationComment;
        forms.clientForm.counselor = data.counselor;
        forms.clientForm.introducer = data.introducer;
        forms.clientForm.introducerComment = data.introducerComment;
        forms.clientForm.name = data.name;
        forms.clientForm.sex = data.clientDetailVO.sex;

        if (data.clientDetailVO.jumin) {
            forms.clientForm.jumin1 = data.clientDetailVO.jumin.slice(0, 6);
            forms.clientForm.jumin2 = data.clientDetailVO.jumin.slice(6, 13);
        }
        forms.clientForm.jumin = data.clientDetailVO.jumin;
        forms.clientForm.address = data.clientDetailVO.address;
        forms.clientForm.juminAddress = data.clientDetailVO.juminAddress;
        forms.clientForm.addressCurrent = data.clientDetailVO.addressCurrent;
        forms.clientForm.roommate = data.clientDetailVO.roommate;
        if (data.clientDetailVO.phone) {
            forms.clientForm.phone1 = data.clientDetailVO.phone.slice(0, 3);
            forms.clientForm.phone2 = data.clientDetailVO.phone.slice(3, 7);
            forms.clientForm.phone3 = data.clientDetailVO.phone.slice(7, 11);
        }
        forms.clientForm.phoneName = data.clientDetailVO.phoneName;
        forms.clientForm.phoneNameRel = data.clientDetailVO.phoneNameRel;
        if (data.clientDetailVO.phone) {
            forms.clientForm.tel1 = data.clientDetailVO.tel.slice(0, 3);
            forms.clientForm.tel2 = data.clientDetailVO.tel.slice(3, 7);
            forms.clientForm.tel3 = data.clientDetailVO.tel.slice(7, 11);
        }
        forms.clientForm.telName = data.clientDetailVO.telName;
        forms.clientForm.telNameRel = data.clientDetailVO.telNameRel;
        if (data.clientDetailVO.telEmergency) {
            forms.clientForm.telEmergency1 = data.clientDetailVO.telEmergency.slice(0, 3);
            forms.clientForm.telEmergency2 = data.clientDetailVO.telEmergency.slice(3, 7);
            forms.clientForm.telEmergency3 = data.clientDetailVO.telEmergency.slice(7, 11);
        }
        forms.clientForm.telEmergencyName = data.clientDetailVO.telEmergencyName;
        forms.clientForm.telEmergencyNameRel = data.clientDetailVO.telEmergencyNameRel;
        forms.clientForm.email = data.clientDetailVO.email;
        forms.clientForm.age = data.age;
        forms.clientForm.ageKor = data.ageKor;
        forms.clientForm.foreigner = data.foreigner;
        forms.clientForm.foreignerDesc = data.foreignerDesc;
        forms.clientForm.guardian = data.guardian;
        forms.clientForm.isHurdles = data.isHurdles;
        forms.clientForm.isHurdlesComment = data.isHurdlesComment;
        forms.clientForm.hurdlesType = data.hurdlesType;
        forms.clientForm.hurdlesReceive = data.hurdlesReceive;
        forms.clientForm.hurdlesCoverage = data.hurdlesCoverage;
        forms.clientForm.historyDate = data.historyDate;
        forms.clientForm.historyAge = data.historyAge;
        forms.clientForm.historyYear = data.historyYear;
        forms.clientForm.family = data.family;
        forms.clientForm.familyEtc = data.familyEtc;
        forms.clientForm.hasChildEtc = data.hasChildEtc;

        let temp = CommonOptions.area4List.find((item) => item.name === data!.area);
        if (temp) {
            forms.clientForm.area1 = "서울";
            forms.clientForm.area4 = data.area;
        } else {
            temp = CommonOptions.area3List.find((item) => item.name === data!.area);
            if (temp) {
                forms.clientForm.area1 = "각 도별";
                forms.clientForm.area3 = data.area;
            } else {
                temp = CommonOptions.area2List.find((item) => item.name === data!.area);
                if (temp) {
                    forms.clientForm.area1 = "광역시";
                    forms.clientForm.area2 = data.area;
                } else {
                    temp = CommonOptions.area2List.find((item) => item.name === data!.area);
                    forms.clientForm.area1 = data.area;
                }
            }
        }
        forms.clientForm.area = data.area;
        forms.clientForm.areaComment = data.areaComment;
        if (data.type) forms.clientForm.type = data.type;
        else forms.clientForm.type = "기록없음";
        forms.clientForm.typeComment = data.typeComment;
        if (data.price) forms.clientForm.price = data.price;
        else forms.clientForm.price = "기록없음";
        forms.clientForm.priceComment = data.priceComment;
        forms.clientForm.broker = data.broker;
        forms.clientForm.brokerComment = data.brokerComment;
        // forms.clientForm.marriageType = data.clientDetailVO.marriageType;
        forms.clientForm.isViolence = data.isViolence;
        forms.clientForm.isViolenceComment = data.isViolenceComment;
        forms.clientForm.isRunaway = data.isRunaway;
        forms.clientForm.isRunawayComment = data.isRunawayComment;
        forms.clientForm.firstRunawayDate = data.firstRunawayDate;
        forms.clientForm.runawayAge = data.runawayAge;
        forms.clientForm.runawayYear = data.runawayYear;
        forms.clientForm.runawayReason = data.runawayReason;
        forms.clientForm.isSexualViolence = data.isSexualViolence;
        forms.clientForm.cntSexualViolence = data.cntSexualViolence;
        forms.clientForm.sexualViolenceLocation = data.sexualViolenceLocation;
        forms.clientForm.sexualViolenceVictims = data.sexualViolenceVictims;
        forms.clientForm.sexualViolenceCase = data.sexualViolenceCase;
        forms.clientForm.safetyStatus = data.safetyStatus;
        forms.clientForm.supportLegal = data.supportLegal;
        forms.clientForm.supportMedical = data.supportMedical;
        forms.clientForm.supportSelfReliance = data.supportSelfReliance;
        forms.clientForm.comment = data.comment;

        return forms.clientForm;
    },

    counselForm: {
        clIdx: 0 as number,
        coIdx: 0 as number,
        date: "" as string,
        csmName: "" as string,
        cstype: "" as string,
        csperson: "" as string,
        cspersonEtc: "" as string,
        title: "" as string,
        processsts: "" as string,
        cktypeSale: 0 as number,
        cktypeDept: 0 as number,
        cktypeForce: 0 as number,
        cktypeLaw: 0 as number,
        cktypePolice: 0 as number,
        cktypeFamily: 0 as number,
        cktypeHome: 0 as number,
        cktypeProblem: 0 as number,
        cktypeEmotional: 0 as number,
        cktypePg: 0 as number,
        cktypeEtc: 0 as number,
        cktypeEtcText: "" as string,
        cktypeCareer: 0 as number,
        cktypeBrand: 0 as number,
        cktypeHealth: 0 as number,
        result: "" as string,
        newInterventionMethod: "" as string,
        newInterventionMethodLaw0: "" as string,
        newInterventionMethodLaw1: "" as string,
        newInterventionMethodLaw2: "" as string,
        newInterventionMethodLaw2Txt: "" as string,
        newInterventionMethodLaw2Cop: "" as string,
        newInterventionMethodLaw2Name: "" as string,
        newInterventionMethodTxt1: "" as string,
        newInterventionMethodMedicalCop: "" as string,
        newInterventionMethodMedicalName: "" as string,
        newInterventionMethodPsychologyCop: "" as string,
        newInterventionMethodPsychologyName: "" as string,
        newInterventionMethodEmotionOtherInstitutions: "" as string,
        newInterventionMethodEmotionOtherInstitutionsDesc: "" as string,
        newInterventionMethodTxt2: "" as string,
        newInterventionMethodTxt3: "" as string,
        newInterventionMethodGroupProgram: "" as string,
        newInterventionMethodGroupProgramDesc: "" as string,
        newInterventionMethodOtherTxt: "" as string,
        newInterventionMethodProfessional: "" as string,
        newInterventionMethodOtherAdviceType: "" as string,
        newSupportingExpenseYn: 0 as number,
        newSupportingIncreaseYn: 0 as number,
        newSupportingExpensePrice: "" as string,
        newSupportingIncreasePrice: "" as string,
        newPrevSupportingExpense: 0 as number,
        newPrevInstitution: "" as string,
        newPrevMedicalPrice: "" as string,
        newPrevLawPrice: "" as string,
        newPrevJobTrainingPrice: "" as string,
        newPrevNotGraspPrice: "" as string,
        newPrevSupportingExpensePrice: 0 as number,
        newSuccessState: 0 as number,
        newSuccessMonthMedicalTreatmentStop: "" as string,
        newSuccessMonthMedicalTreatmentIng: "" as string,
        newSuccessMonthMedicalTreatmentCompleteControl: "" as string,
        newSuccessMonthLawasWin: "" as string,
        newSuccessMonthLawasLose: "" as string,
        newSuccessMonthLawasProtective: "" as string,
        newSuccessMonthLawasBankruptcyDishonestly: "" as string,
        newSuccessMonthLawasMediation: "" as string,
        newSuccessMonthLawasDefer: "" as string,
        newSuccessMonthJawhalJobService: "" as string,
        newSuccessMonthJawhalJobWorker: "" as string,
        newSuccessMonthJawhalOfficejob: "" as string,
        newSuccessMonthJawhalSuppasCerti: "" as string,
        newSuccessMonthJawhalCertificateExamination: "" as string,
        newSuccessMonthJawhalSuppasUniv: "" as string,
        newSuccessMonthJawhalHighdegreeGet: "" as string,
        newSuccessMonthJawhalRegisterSchool: "" as string,
        newSuccessMonthJawhalSuppasOwnbusi: "" as string,
        newSuccessMonthJawhalLevelup: "" as string,
        newSuccessMonthJawhalEtc: "" as string,
        newSuccessMonthJawhalEtcTxt: "" as string,
        newSuccessMonthJawhalJobRegular: "" as string,
        newSuccessMonthJawhalJobNonRegular: "" as string,
        newSuccessMonthJawhalJobDaily: "" as string,
        newSuccessMonthJawhalJobIntern: "" as string,
        newSuccessMonthJawhalJobEtc: "" as string,
        newSuccessMonthJawhalJobEtcTxt: "" as string,
        lawasDesc: "" as string,
        newCounselorDesc: "" as string,
    },

    convertCounselDataFromApi: (data: types.counsel.CounselVO) => {
        forms.counselForm.clIdx = data.clIdx;
        forms.counselForm.coIdx = data.coIdx;
        forms.counselForm.date = CommonUtils.dateFormatYYYYMMDD(data.date, "-");
        forms.counselForm.csmName = data.csmName;
        forms.counselForm.cstype = data.cstype;
        forms.counselForm.csperson = data.csperson;
        forms.counselForm.cspersonEtc = data.cspersonEtc;
        forms.counselForm.title = data.title;
        forms.counselForm.processsts = data.counselDetailVO.processsts;
        forms.counselForm.cktypeSale = data.cktypeSale;
        forms.counselForm.cktypeDept = data.cktypeDept;
        forms.counselForm.cktypeForce = data.cktypeForce;
        forms.counselForm.cktypeLaw = data.cktypeLaw;
        forms.counselForm.cktypePolice = data.cktypePolice;
        forms.counselForm.cktypeFamily = data.cktypeFamily;
        forms.counselForm.cktypeHome = data.cktypeHome;
        forms.counselForm.cktypeProblem = data.cktypeProblem;
        forms.counselForm.cktypeEmotional = data.cktypeEmotional;
        forms.counselForm.cktypePg = data.cktypePg;
        forms.counselForm.cktypeEtc = data.cktypeEtc;
        forms.counselForm.cktypeEtcText = data.cktypeEtcText;
        forms.counselForm.cktypeCareer = data.cktypeCareer;
        forms.counselForm.cktypeBrand = data.cktypeBrand;
        forms.counselForm.cktypeHealth = data.cktypeHealth;
        forms.counselForm.result = data.result;
        forms.counselForm.newInterventionMethod = data.newInterventionMethod;
        forms.counselForm.newInterventionMethodLaw0 = data.newInterventionMethodLaw0;
        forms.counselForm.newInterventionMethodLaw1 = data.newInterventionMethodLaw1;
        forms.counselForm.newInterventionMethodLaw2 = data.newInterventionMethodLaw2;
        forms.counselForm.newInterventionMethodLaw2Txt = data.newInterventionMethodLaw2Txt;
        forms.counselForm.newInterventionMethodLaw2Cop = data.newInterventionMethodLaw2Cop;
        forms.counselForm.newInterventionMethodLaw2Name = data.newInterventionMethodLaw2Name;
        forms.counselForm.newInterventionMethodTxt1 = data.newInterventionMethodTxt1;
        forms.counselForm.newInterventionMethodMedicalCop = data.newInterventionMethodMedicalCop;
        forms.counselForm.newInterventionMethodMedicalName = data.newInterventionMethodMedicalName;
        forms.counselForm.newInterventionMethodPsychologyCop = data.newInterventionMethodPsychologyCop;
        forms.counselForm.newInterventionMethodPsychologyName = data.newInterventionMethodPsychologyName;
        forms.counselForm.newInterventionMethodEmotionOtherInstitutions = data.newInterventionMethodEmotionOtherInstitutions;
        forms.counselForm.newInterventionMethodEmotionOtherInstitutionsDesc = data.newInterventionMethodEmotionOtherInstitutionsDesc;
        forms.counselForm.newInterventionMethodTxt2 = data.newInterventionMethodTxt2;
        forms.counselForm.newInterventionMethodTxt3 = data.newInterventionMethodTxt3;
        forms.counselForm.newInterventionMethodGroupProgram = data.newInterventionMethodGroupProgram;
        forms.counselForm.newInterventionMethodGroupProgramDesc = data.newInterventionMethodGroupProgramDesc;
        forms.counselForm.newInterventionMethodOtherTxt = data.newInterventionMethodOtherTxt;
        forms.counselForm.newInterventionMethodProfessional = data.newInterventionMethodProfessional;
        forms.counselForm.newInterventionMethodOtherAdviceType = data.newInterventionMethodOtherAdviceType;
        forms.counselForm.newSupportingExpenseYn = data.newSupportingExpenseYn;
        forms.counselForm.newSupportingIncreaseYn = data.newSupportingIncreaseYn;
        forms.counselForm.newSupportingExpensePrice = data.newSupportingExpensePrice;
        forms.counselForm.newSupportingIncreasePrice = data.newSupportingIncreasePrice;
        forms.counselForm.newPrevSupportingExpense = data.newPrevSupportingExpense;
        forms.counselForm.newPrevInstitution = data.newPrevInstitution;
        forms.counselForm.newPrevMedicalPrice = data.newPrevMedicalPrice;
        forms.counselForm.newPrevLawPrice = data.newPrevLawPrice;
        forms.counselForm.newPrevJobTrainingPrice = data.newPrevJobTrainingPrice;
        forms.counselForm.newPrevNotGraspPrice = data.newPrevNotGraspPrice;
        forms.counselForm.newPrevSupportingExpensePrice = data.newPrevSupportingExpensePrice;
        forms.counselForm.newSuccessState = data.newSuccessState;
        forms.counselForm.newSuccessMonthMedicalTreatmentStop = data.newSuccessMonthMedicalTreatmentStop;
        forms.counselForm.newSuccessMonthMedicalTreatmentIng = data.newSuccessMonthMedicalTreatmentIng;
        forms.counselForm.newSuccessMonthMedicalTreatmentCompleteControl = data.newSuccessMonthMedicalTreatmentCompleteControl;
        forms.counselForm.newSuccessMonthLawasWin = data.newSuccessMonthLawasWin;
        forms.counselForm.newSuccessMonthLawasLose = data.newSuccessMonthLawasLose;
        forms.counselForm.newSuccessMonthLawasProtective = data.newSuccessMonthLawasProtective;
        forms.counselForm.newSuccessMonthLawasBankruptcyDishonestly = data.newSuccessMonthLawasBankruptcyDishonestly;
        forms.counselForm.newSuccessMonthLawasMediation = data.newSuccessMonthLawasMediation;
        forms.counselForm.newSuccessMonthLawasDefer = data.newSuccessMonthLawasDefer;
        forms.counselForm.newSuccessMonthJawhalJobService = data.newSuccessMonthJawhalJobService;
        forms.counselForm.newSuccessMonthJawhalJobWorker = data.newSuccessMonthJawhalJobWorker;
        forms.counselForm.newSuccessMonthJawhalOfficejob = data.newSuccessMonthJawhalOfficejob;
        forms.counselForm.newSuccessMonthJawhalSuppasCerti = data.newSuccessMonthJawhalSuppasCerti;
        forms.counselForm.newSuccessMonthJawhalCertificateExamination = data.newSuccessMonthJawhalCertificateExamination;
        forms.counselForm.newSuccessMonthJawhalSuppasUniv = data.newSuccessMonthJawhalSuppasUniv;
        forms.counselForm.newSuccessMonthJawhalHighdegreeGet = data.newSuccessMonthJawhalHighdegreeGet;
        forms.counselForm.newSuccessMonthJawhalRegisterSchool = data.newSuccessMonthJawhalRegisterSchool;
        forms.counselForm.newSuccessMonthJawhalSuppasOwnbusi = data.newSuccessMonthJawhalSuppasOwnbusi;
        forms.counselForm.newSuccessMonthJawhalLevelup = data.newSuccessMonthJawhalLevelup;
        forms.counselForm.newSuccessMonthJawhalEtc = data.newSuccessMonthJawhalEtc;
        forms.counselForm.newSuccessMonthJawhalEtcTxt = data.newSuccessMonthJawhalEtcTxt;
        forms.counselForm.newSuccessMonthJawhalJobRegular = data.newSuccessMonthJawhalJobRegular;
        forms.counselForm.newSuccessMonthJawhalJobNonRegular = data.newSuccessMonthJawhalJobNonRegular;
        forms.counselForm.newSuccessMonthJawhalJobDaily = data.newSuccessMonthJawhalJobDaily;
        forms.counselForm.newSuccessMonthJawhalJobIntern = data.newSuccessMonthJawhalJobIntern;
        forms.counselForm.newSuccessMonthJawhalJobEtc = data.newSuccessMonthJawhalJobEtc;
        forms.counselForm.newSuccessMonthJawhalJobEtcTxt = data.newSuccessMonthJawhalJobEtcTxt;
        forms.counselForm.lawasDesc = data.counselDetailVO.lawasDesc;
        forms.counselForm.newCounselorDesc = data.counselDetailVO.newCounselorDesc;
        return forms.counselForm;
    },
};
